/* file description */
import { UseGetTreeData } from './type';
import { useEffect, useState, useRef } from 'react';
import { COLUMN_FROM } from '../../../effects/consts';
import { getModuleRecordList, getApiData } from '@/common/asset-apis/assetModel';
import { cloneDeep } from 'lodash';

export const useGetTreeData: UseGetTreeData = ({ field, API, form, config, columnFrom, storeValue, rowsData, moduleInfo }) => {
  const { dispatchEvent, destroyEvent, taskInfo } = config.metaStore || {};
  const [apiParamsList, setapiParamsList] = useState({});
  const [filterList, setfilterList] = useState({});
  const { dataKey, treeId, prefilter, isFilter, label, value, treePid, treeKey, dataType, rootCode, canChooseLevel, isOpenApi, apiKeyList, parentList, apiUrl } = field?.bizConfig || {};
  const [treeData, setTreeData] = useState<any[]>([]);
  const [optionData, setOptionData] = useState<any[]>([]);
  const apiRef = useRef({});
  const filterRef = useRef({});

  // const apiParamsList: Record<any, any> = {};
  // const filterList: Record<any, any> = {};
  // let headData: Record<any, any> = {};
  // if (storeValue) {
  //   Object.keys(storeValue).forEach((key: any) => {
  //     if (!Array.isArray(storeValue[key])) {
  //       headData = storeValue[key];
  //     }
  //   });
  // }

  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   if (rowsData?.[config.rowIndex]) {
  //     if (isOpenApi) {
  //       apiKeyList?.forEach((item: any) => {
  //         if (item.isValueFromMainModule) {
  //           apiParamsList[item.apiKey] = headData?.[item.apiValueModule];
  //         } else {
  //           apiParamsList[item.apiKey] = rowsData?.[config.rowIndex]?.[item.apiValue];
  //         }
  //       });
  //     } else {
  //       if (parentList?.length > 0) {
  //         parentList?.forEach((item: any) => {
  //           filterList[item.parentListKey] = form.getFieldsValue()[config.rowIndex]?.[item.parentListValue];
  //         });
  //       }
  //     }
  //   }
  // }
  // if (columnFrom === COLUMN_FROM.FORM) {
  //   if (isOpenApi) {
  //     apiKeyList?.forEach((item: any) => {
  //       if (item.isValueFromMainModule) {
  //         apiParamsList[item.apiKey] = headData?.[item.apiValueModule];
  //       } else {
  //         apiParamsList[item.apiKey] = form.getFieldsValue()[item.apiValue];
  //       }
  //     });
  //   } else {
  //     if (parentList?.length > 0) {
  //       parentList?.forEach((item: any) => {
  //         filterList[item.parentListKey] = form.getFieldsValue()?.[item.parentListValue];
  //       });
  //     }
  //   }
  // }
  useEffect(() => {
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    if (columnFrom === COLUMN_FROM.TABLE) {
      if (rowsData?.[config.rowIndex]) {
        if (isOpenApi) {
          apiKeyList?.forEach((item: any) => {
            if (item.isValueFromMainModule) {
              apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
            } else {
              apiRef.current = { ...apiRef.current, [item.apiKey]: rowsData?.[config.rowIndex]?.[item.apiValue] };
            }
          });
        } else {
          parentList?.forEach((item: any) => {
            filterRef.current = { ...filterRef.current, [item.parentListKey]: config.formValue[config.rowIndex]?.[item.parentListValue] };
          });
        }
      }
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      if (isOpenApi) {
        apiKeyList?.forEach((item: any) => {
          if (item.isValueFromMainModule) {
            apiRef.current = { ...apiRef.current, [item.apiKey]: headData?.[item.apiValueModule] };
          } else {
            apiRef.current = { ...apiRef.current, [item.apiKey]: config.formValue[item.apiValue] };
          }
        });
      } else {
        parentList?.forEach((item: any) => {
          filterRef.current = { ...filterRef.current, [item.parentListKey]: config.formValue?.[item.parentListValue] };
        });
      }
    }

    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const idList: any[] = [];
    if (isOpenApi) {
      apiKeyList?.forEach((item: any) => {
        const events = [{
          code: field.name,
          name: field.label,
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: item.isValueFromMainModule ? mainModuleCode : moduleInfo.handle,
          fieldName: item.isValueFromMainModule ? item.apiValueModule : item.apiValue,
          rowIndex: config.rowIndex,
          fun: (value: any) => {
            apiRef.current = { ...apiRef.current, [item.apiKey]: value };
            setapiParamsList({ ...apiRef.current, [item.apiKey]: value });
          },
        }];
        const ids = dispatchEvent?.(events);
        idList.push(ids);
      });
    } else {
      parentList?.forEach((item: any) => {
        const events = [{
          code: field.name,
          name: field.label,
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: moduleInfo.handle,
          fieldName: item.parentListValue,
          rowIndex: config.rowIndex,
          fun: (value: any) => {
            filterRef.current = { ...filterRef.current, [item.parentListKey]: value };
            setfilterList({ ...filterRef.current, [item.parentListKey]: value });
          },
        }];
        const ids = dispatchEvent?.(events);
        idList.push(ids);
      });
    }
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  const convertTree = (data: Record<string, any>) => {
    const obj: Record<string, any> = {};
    data.values.forEach((item: Record<string, any>) => {
      obj[item.name] = item.value;
    });
    obj.recordID = data.recordID;
    obj.id = obj[treeKey];
    obj.pId = obj[treePid] || 0;
    obj.value = obj[value];
    obj.title = obj[label];
    return obj;
  };

  // 给数据添加层级
  const buildTree = (treeData: any[], pId: any, parentLevel: number) => {
    if (!canChooseLevel) {
      return treeData;
    }
    let chooseList = canChooseLevel.split(',');
    chooseList = chooseList.map((item: string) => Number(item));
    for (let i = 0; i < treeData.length; i++) {
      if (treeData[i].pId === pId) {
        treeData[i].level = parentLevel + 1;
        if (!chooseList.includes(treeData[i].level)) {
          treeData[i].disabled = true;
        }
        buildTree(treeData, treeData[i].id, treeData[i].level);
      }
    }
    return treeData;
  }

  useEffect(() => {
    if (isOpenApi) {
      return;
    }
    getModuleRecordList(
      API.FetchAPI,
      treeId,
      dataKey,
      {
        moduleID: dataKey,
        namespaceID: treeId,
        limit: 100000,
        filter: isFilter ? (dataType || prefilter || '') : '',
      },
    ).then((res) => {
      const { set = [] } = res || {};
      const convertData = set.map((item: any) => convertTree(item));
      const tree = buildTree(convertData, rootCode || 0, 0);
      setOptionData(tree);
    });
  }, []);

  useEffect(() => {
    if (isOpenApi) {
      getApiData(API?.FetchAPI, apiUrl, apiRef.current).then((res: any) => {
        const { set = [] } = res || {};
        const convertData = set.map((item: any) => convertTree(item));
        const tree = buildTree(convertData, rootCode || 0, 0);
        setTreeData(tree);
      });
    }
    if (optionData.length > 0) {
      const filterData = optionData.filter((item: any) => {
        if (Object.keys(filterRef.current)?.length > 0) {
          return Object.keys(filterRef.current).every((key: string) => {
            return filterRef.current[key] === item[key];
          });
        } else {
          return true;
        }
      });
      setTreeData(filterData);
    }
  }, [JSON.stringify(filterRef.current), optionData, JSON.stringify(apiRef.current)]);
  
  return {
    treeData,
  };
};
